import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Login from "./containers/Login/Login";
import routes from "./constants/routes";
import Upload from "containers/Upload/Upload";
import History from "containers/History/History";
import AuthenticatedRoute from "components/AuthenticatedRoute";
import PageNotFound from "components/PageNotFound/PageNotFound";
import HomePage from "containers/HomePage/HomePage";
import CustomerOrders from "containers/CustomerOrders/CustomerOrders";
import OrderDetails from "containers/OrderDetails/OrderDetails";

const AppRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to={routes.homePage.homePage} />} />
    <Route path={routes.login.root} element={<Login />} />
    <Route element={<AuthenticatedRoute />}>
      <Route path={routes.homePage.homePage} element={<HomePage />} />
      <Route
        path={routes.customerOrders.customerOrders}
        element={<CustomerOrders />}
      />
      <Route
        path={routes.orderDetails.orderDetails}
        element={<OrderDetails />}
      />
      <Route path={routes.upload.upload} element={<Upload />} />
      <Route path={routes.history.history} element={<History />} />
      <Route path="*" element={<PageNotFound />} />
    </Route>
  </Routes>
);

export default AppRoutes;
